import { faEnvelope, faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import user from "../../Assets/Images/user.png";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import pdf from "../../Assets/Images/pdf.webp";
import { NavLink } from "react-router-dom";
function Profile({ userData }) {
  console.log(userData);
  return (
    <>
      <div className="card-header bg-transparent ">
        <h4 className="card-header-title">
          <FontAwesomeIcon icon={faUserCircle} /> My Profile
        </h4>
      </div>
      <div className="profile_card card mt-4">
        <div className="card-body profile-user-box">
          <div className="row">
            <div className="col-sm-8">
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="avatar-lg">
                    <img
                      src={user}
                      alt="user image"
                      className="rounded-circle img-thumbnail"
                    />
                  </div>
                </div>
                <div className="col">
                  <div>
                    <h4 className="mt-1 mb-1 text-white">{userData?.first_name}</h4>
                    <p className="font-13 text-white-50">
                      {" "}
                      <FontAwesomeIcon icon={faEnvelope} /> {userData?.email}
                    </p>
                    {/* <p className="font-13 text-white-50">
                      {" "}
                      <FontAwesomeIcon icon={faPhone}/> {userData?.phone_no}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-4">
              <div className="text-center mt-sm-0 mt-3 text-sm-end">
                <NavLink to="/dashboard/edit-profile">
                  <button type="button" className="btn btn-light">
                    <i className="mdi mdi-account-edit me-1"></i> Edit Profile
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4 className="mt-4">Profile Info</h4>
      <div className="row ">
        <div className="col-md-6 mt-2">
          <label className="fw-bold">Full Name</label>
          <p>{userData?.first_name}</p>
        </div>
        <div className="col-md-6 mt-2">
          <label className="fw-bold">Email</label>
          <p>{userData?.email}</p>
        </div>
        <div className="col-md-6 mt-2">
          <label className="fw-bold">Position</label>
          <p>{userData?.position}</p>
        </div>
      </div>
      <h4 className="mt-4">Company Info</h4>
      <div className="row ">
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Company Name</label>
          <p>
            {userData?.company_name === null ? "N/A" : userData?.company_name}
          </p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Company Contact</label>
          <p>{userData?.phone_no === null ? "N/A" : userData?.phone_no}</p>
        </div>

        <div className="col-md-4 mt-2">
          <label className="fw-bold">Country</label>
          <p>{userData?.country === null ? "N/A" : userData?.country}</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">City</label>
          <p>{userData?.city === null ? "N/A" : userData?.city}</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Street</label>
          <p>
            {userData?.company_address === null
              ? "N/A"
              : userData?.company_address}
          </p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Postal Code</label>
          <p>{userData?.zip_code === null ? "N/A" : userData?.zip_code}</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Website</label>
          <p>
            {userData?.company_Website === null
              ? "N/A"
              : userData?.company_Website}
          </p>
        </div>
        <div className=" mt-2">
          <p className="fw-bold">Id Proof</p>
          {userData?.id_Card !== null ? (
            <img
              className="mt-2 id-image"
              style={{ width: "50%", height: "auto", objectFit: "cover" }}
            alt="id proof"
              src={
                "https://api.synchtravel.com/storage/app/public/b2b_Agents_Documents/id_Card/" +
                userData?.id_Card
              }
            />
          ) : (
            "No ID Proof"
          )}
        </div>
        <div className=" mt-2">
          <label className="fw-bold">Business Documents</label>
          <div
            style={{ flexWrap: "wrap" }}
            className="d-flex align-items-center"
          >
            {userData.business_Document !== undefined &&
              userData.business_Document !== null &&
              JSON.parse(userData.business_Document).map((item, index) => {
                // Get the file extension to differentiate between image and PDF
                const fileExtension = item.split(".").pop().toLowerCase();
                const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                  fileExtension
                );
                const fileUrl =
                  "https://api.synchtravel.com/public/uploads/b2b_Agents_Documents/business_Document/" +
                  item;

                return (
                  <div key={index} style={{ margin: "10px" }}>
                    {isImage ? (
                      // Render image if it's an image file
                      <img
                        style={{
                          width: "50%",
                          height: "auto",
                          objectFit: "cover",
                          
                        }}
                        className='business-image'
                        src={fileUrl}
                        alt={`Document ${index + 1}`}
                      />
                    ) : (
                      // Render a link or icon for PDFs
                      <a
                        href={fileUrl}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                        className="text-center"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={pdf} // Add a generic PDF icon here
                          alt={`PDF Document ${index + 1}`}
                          style={{
                            width: "auto",
                            height: "15em",
                            objectFit: "cover",
                          }}
                        />
                        <p>PDF Document {index + 1}</p>
                      </a>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      {/* <h4 className="mt-4">Billing Info</h4>
      <div className="row ">
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Account Name</label>
          <p>{userData?.account_Name === null ? 'N/A' : userData?.account_Name}</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Account Number</label>
          <p>{userData?.account_Number === null ? 'N/A' : userData?.account_Number}</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">IBAN</label>
          <p>{userData?.IBAN_Number === null ? 'N/A' : userData?.IBAN_Number}</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="fw-bold">Account Credit</label>
          <p>{userData?.account_Credit === null ? 'N/A' : userData?.account_Credit}</p>
        </div>
        <div className=" mt-2">
          <label className="fw-bold">Account Documents</label>
          <div style={{flexWrap:'wrap'}} className="d-flex align-items-center">
            {userData.account_Document !==undefined&& userData.account_Document !==null && JSON.parse(userData.account_Document).map((item, index) => {
              // Get the file extension to differentiate between image and PDF
              const fileExtension = item.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                fileExtension
              );
              const fileUrl =
                "https://api.synchtravel.com/public/uploads/b2b_Agents_Documents/account_Document/" +
                item;

              return (
                <div key={index} style={{ margin: "10px" }}>
                  {isImage ? (
                    // Render image if it's an image file
                    <img
                      style={{
                        width: "auto",
                        height: "15em",
                        objectFit: "cover",
                      }}
                      src={fileUrl}
                      alt={`Document ${index + 1}`}
                    />
                  ) : (
                    // Render a link or icon for PDFs
                    <a
                      href={fileUrl}
                      target="_blank"
                      style={{ textDecoration: "none" }}
                      className="text-center"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={pdf} // Add a generic PDF icon here
                        alt={`PDF Document ${index + 1}`}
                        style={{
                          width: "auto",
                          height: "15em",
                          objectFit: "cover",
                        }}
                      />
                      <p>PDF Document {index + 1}</p>
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div> */}
    </>
  );
}
export default Profile;
